var _path, _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6432 6.61065C34.557 6.54821 34.4546 6.517 34.351 6.517V6.51575H19.3657C19.0897 6.51575 18.8662 6.73928 18.8662 7.01525V33.9887C18.8662 34.2647 19.0897 34.4882 19.3657 34.4882H21.8633V37.9847C21.8633 38.1458 21.9407 38.2957 22.0706 38.3906C22.1567 38.453 22.2591 38.4843 22.3628 38.4843C22.4152 38.4843 22.4689 38.4755 22.5201 38.458L34.5083 34.462C34.7119 34.3945 34.8505 34.2035 34.8505 33.9887V7.0165C34.8505 6.85541 34.773 6.70556 34.6432 6.61065ZM22.2054 10.5393C22.0006 10.6067 21.8633 10.7978 21.8633 11.0126V33.4904H19.8652V7.51601H31.2727L22.2054 10.5393Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4516_31530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.047 24.6588L10.7594 23.9464L8.44535 21.6273H16.6152V20.6168H8.44535L10.7644 18.2977L10.047 17.5853L6.51025 21.1221L10.047 24.6588Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.437,
    cy: 21.1221,
    r: 6.06299,
    fill: "#44C032"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4516_31530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4322 16.0696C31.6432 16.0696 29.3848 18.3331 29.3848 21.1221C29.3848 23.9111 31.6432 26.1746 34.4322 26.1746C37.2262 26.1746 39.4898 23.9111 39.4898 21.1221C39.4898 18.3331 37.2262 16.0696 34.4322 16.0696ZM34.4373 25.1641C32.2041 25.1641 30.3953 23.3553 30.3953 21.1221C30.3953 18.8889 32.2041 17.0801 34.4373 17.0801C36.6705 17.0801 38.4793 18.8889 38.4793 21.1221C38.4793 23.3553 36.6705 25.1641 34.4373 25.1641ZM34.6899 18.5958H33.932V21.6273L36.5846 23.2189L36.9635 22.5974L34.6899 21.2484V18.5958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4516_31530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.126,
    height: 12.126,
    fill: "white",
    transform: "translate(17.626 27.1851) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4516_31530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.126,
    height: 12.126,
    fill: "white",
    transform: "translate(28.374 15.0591)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.75e7a495d2df64acc138f6b0e7e5c4e8.svg";
export { ForwardRef as ReactComponent };